import { LoginSocialBarNativeMenu } from './LoginSocialBarNativeMenu';

export default LoginSocialBarNativeMenu;
